<template>
    <div class="specialGoods">
        <Header ref="header" :title="title" @backPage="onBack" :color="color" :iconColor='iconColor' :cancleLine='true'>
            <img slot='headRight' src="../../../assets/img/b2b/icon_white_search@2x.png" alt="">
        </Header>
        <div class="container" :class="{'container2': $iosHeightDiv2() == 'isIosHeight', 'container3': $iosHeightDiv2() == 'isIosHeight2'}" v-show="show">
            <div class="activeImg">
                <img v-show="activeImage" :src="activeImage" alt="活动banner">
            </div>
            <div class="tab">
                <van-tabs v-model="active" :swipe-threshold=2 :line-height='0' @click='tabCut'>
                    <van-tab v-for="(value, index) in specialZoneData" :key="index">
                        <div slot="title">
                            <div class="tabItem" slot="title">
                                <div class="tabTime" :class="{'tabOpacity': active != index}">{{value.startTime | formatDate4}}</div>
                                <div class="tabStatu" :class="{'tabOpacity': active != index}" v-text="value.underwayStatus == 1 ? '即将开场' : '抢购进行中'"></div>
                            </div>
                        </div>
                        <div class="body">
                            <div v-for="(item, index) in specialDatas.skuList" :key="index">
                                <div class="special" @click="onBuy(item)">
                                    <div class="img-box">
                                        <img :src="$viewImageNew(item.pictureUrl, 400,400)" alt="特价商品图片">
                                    </div>
                                    <div class="mainPart">
                                        <div class="goodName">{{item.skuShowName}}</div>
                                        <div class="goodIntro">{{item.sellingPoint}}</div>
                                        <div class="case">
                                            <div class="others">
                                                <div class="price">
                                                    <div class="discount">
                                                        <span class="saleP" v-if="$isPriceShow()">
                                                            <priceShow :showPrice="item.salePrice" showPriceColor="#FF7A45" textAlign="left" showOrigin :cancelPrice="item.sellPrice" :showOriginColumn="false">
                                                            </priceShow>
                                                        </span>
                                                        <span class="span" v-else>
                                                            <div class="saleP isPrice">
                                                                会员价<i class="originP">￥{{item.sellPrice}}</i>
                                                            </div>
                                                        </span>
                                                    </div>
                                                    <div class="progress-box">
                                                        <div class="progress" :class="{'progressSellOut': specialDatas.underwayStatus == 2 && item.inventoryRemainNum == 0}">
                                                            <mt-progress :value="(item.inventoryOriginNum - item.inventoryRemainNum)*100/item.inventoryOriginNum" :barHeight="24"></mt-progress>
                                                            <span class="alreadyBuy">
                                                                {{ item.inventoryRemainNum > 0 ? '已抢购'+ (item.inventoryOriginNum - item.inventoryRemainNum) + '件' : '已抢完'}}</span>
                                                        </div>
                                                        <span class="percent">{{((item.inventoryOriginNum - item.inventoryRemainNum)*100/item.inventoryOriginNum).toFixed(0)}}%</span>
                                                    </div>
                                                </div>
                                                <div class="btn" v-if="specialDatas.underwayStatus == 2 && item.inventoryRemainNum > 0">去抢购</div>
                                                <div class="btn sellOut" v-else-if="specialDatas.underwayStatus == 1" disabled>未开始</div>
                                                <div class="btn sellOut" v-else disabled>去看看</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="hr" v-if="index != (specialDatas.skuList.length - 1)"></div>
                            </div>
                        </div>
                    </van-tab>
                    <div class="tabTips">
                        <!-- <span class="Tipscontent">数量有限 先下先得</span> -->
                        <div class="toEnd" :class="specialDatas.underwayStatus == 1 ? 'isCome' : 'inProgress'">
                            <div class="lightning">
                                <img :src="specialDatas.underwayStatus == 1 ? isComeImg : inProgressImg" />
                                <div>{{specialDatas.underwayStatus == 1 ? '距离开始' : '距离结束'}}</div>
                            </div>
                            <div class="countDown">
                                <vantCountDown :underway='specialDatas.underwayStatus == 1' :time="specialDatas.countDownTime" @onCountDown='onCountDown' v-if="specialDatas.countDownTime" />
                            </div>
                        </div>
                    </div>
                </van-tabs>
            </div>
        </div>
        <SpecialZoneSkeleton v-show="!show" />
    </div>
</template>
<script>
import vantCountDown from '../common/vanCountDown'
import Header from '../../common/header'
import { mapMutations, mapActions } from 'vuex'
import { Modal } from '../api/model.js'
import priceShow from '../../common/priceShow'
import SpecialZoneSkeleton from './skeleton/specialZone'
import { Toast } from 'vant'
export default {
    name: 'specialZone',
    components: {
        Header,
        vantCountDown,
        priceShow,
        SpecialZoneSkeleton
    },
    data () {
        return {
            show: false,
            title: this.$route.query.type ? '首单特价' : '秒杀专区',
            color: '#ff4d4f',
            iconColor: 'white',
            userInfo: '',
            activityParams: '',
            active: 0,
            specialDatas: {
                countDownTime: 0
            },
            specialZoneData: [],
            activeImage: '',
            isComeImg: require('../../../assets/img/b2b/lightningDark.png'),
            inProgressImg: require('../../../assets/img/b2b/lightning.png')
        }
    },
    watch: {
        '$route' (to, from) {
            Modal.beforeClose()
        }
    },
    methods: {
        ...mapMutations({
            tabRemember: 'TABREMEMBER'
        }),
        ...mapActions(['getSpikeZone', 'getSpikeInfo', 'setActivity']),
        onBack () {
            this.$router.push('/b2b/home/index')
        },
        onSubmit () {
            localStorage.setItem('searchBack', this.$router.history.current.fullPath)
            this.$router.push('/b2b/search/index')
        },
        onCountDown () {
            this.spikeZone()
        },
        onBuy (val) {
            this.tabRemember(this.active)
            this.activityParams.brand = val.brandName
            this.activityParams.thirdClass = val.categoryName
            localStorage.setItem('spikeData', JSON.stringify(this.activityParams))
            localStorage.setItem('goodsDetailBack', this.$router.history.current.fullPath)
            this.$router.push({ path: '/b2b/companyActivity/goodsDetail', query: { skuId: val.skuId, spikeId: this.specialDatas.spikeId, type: this.$route.query.type } })
        },
        async tabCut () {
            this.getSpikeInfo({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode,
                spikeId: this.specialZoneData[this.active].spikeId
            }).then((data) => {
                this.specialDatas = data
                this.activeImage = data.image
                this.show = true
                this.$nextTick(() => {
                    this.activityInfo()
                })
            })
        },
        async spikeZone () {
            this.getSpikeZone({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode,
                memberScopeList: this.$route.query.type || '1,3'
            }).then((data) => {
                if (!data) {
                    Toast({
                        message: '活动已结束, 即将返回首页',
                        duration: 1500
                    })
                    setTimeout(() => {
                        this.$router.replace({ path: '/b2b/home/index' })
                    }, 2000)
                    return false
                }
                this.specialZoneData = data
                if (this.$route.query.spikeId) {
                    data.forEach((item, index) => {
                        if (item.spikeId == this.$route.query.spikeId) {
                            this.active = index
                            this.specialDatas = item
                        }
                    })
                } else {
                    this.specialDatas = data[this.active]
                }
                this.activeImage = data[this.active].image
                this.show = true
                this.$nextTick(() => {
                    this.activityInfo()
                })
                // this.tabCut()
            })
        },
        activityInfo () {
            this.activityParams = {
                ...this.activityParams,
                activityId: this.specialDatas.spikeId,
                activityName: this.specialDatas.spikeName,
                productId: '',
                productName: '',
                brand: '',
                thirdClass: ''
            }
            this.setActivity(this.activityParams)
            localStorage.setItem('spikeData', JSON.stringify(this.activityParams))
        }
    },
    async mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.activityParams = JSON.parse(localStorage.getItem('spikeData'))
        this.active = this.$store.state.b2b.tabRemember
        this.spikeZone()
    }
}
</script>
<style lang="scss" scoped>
// 进度条样式
/deep/ .progress {
    position: relative;
    z-index: 99;
}
/deep/ .mt-progress-runway {
    background-color: #ffc9ca;
}
/deep/ .mt-progress-progress {
    background-color: #ff4d4f;
}
.progressSellOut {
    /deep/ .mt-progress-progress {
        background-color: #ababab !important;
    }
}
// tab切换样式
/deep/ .van-tabs {
    height: 100%;
}
/deep/ .van-tabs__wrap--scrollable .van-tab {
    padding: 0;
}
/deep/ .van-tabs__nav {
    padding: 0 !important;
    background-color: #ff4d4f;
    border-bottom-left-radius: 40px;
    border-bottom-right-radius: 40px;
}
/deep/ .van-tabs__nav .van-tab {
    flex-basis: 50% !important;
    line-height: initial;
}
/deep/ .van-tab__text--ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -webkit-line-clamp: initial;
}
/deep/ .van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
    border: none;
}
/deep/ .van-tabs__content {
    height: calc(100% - 212px);
    overflow: auto;
}
/deep/.van-tabs--line .van-tabs__wrap {
    position: relative;
    height: 212px;
    padding: 0;
}
.specialGoods {
    font-family: PingFangSC;
    height: 100%;
    .container {
        height: calc(100% - 100px);
        position: relative;
        overflow: hidden;
        &.container2 {
            height: calc(100% - 145px);
        }
        &.container3 {
            height: calc(100% - 192px);
        }
        .activeImg {
            img {
                width: 100%;
                height: 100%;
                border-radius: 16px;
            }
            background: #ff4d4f;
            padding: 0 24px;
            height: 262px;
        }
        .tab {
            height: calc(100% - 262px);
            text-align: center;
            .tabItem {
                height: 204px;
                color: #ffffff;
                img {
                    height: 262px;
                    // position: absolute;
                }
                .tabTime {
                    font-weight: bold;
                    font-size: 32px;
                    padding-top: 16px;
                }
                .tabStatu {
                    font-size: 24px;
                    padding: 0 0 122px 0;
                    transform-origin: center 0%;
                }
                .tabOpacity {
                    font-weight: 400;
                    opacity: 0.5;
                }
            }
        }
        .tabTips {
            position: absolute;
            top: 116px;
            padding: 32px 0;
            width: calc(100% - 48px);
            margin: 0 24px;
            background-color: #fff;
            border-radius: 16px 16px 0 0;
            display: flex;
            justify-content: center;
            align-items: center;
            border-bottom: 2px solid #eeeeee;
            .Tipscontent {
                font-family: PingFangSC;
                color: #000000;
                padding-left: 32px;
                font-size: 28px;
                font-weight: 400;
                display: inline-block;
                height: 32px;
            }
            .toEnd {
                &.isCome {
                    color: #999999;
                }
                &.inProgress {
                    color: #000000;
                }
                display: flex;
                align-items: center;
                padding-right: 32px;
                font-size: 24px;
                font-weight: 400;
                .lightning {
                    display: flex;
                    align-items: center;
                    img {
                        width: 32px;
                        height: 32px;
                    }
                    div {
                        font-size: 24px;
                        height: 32px;
                        line-height: 32px;
                    }
                }
                .countDown {
                    padding-left: 16px;
                    height: 32px;
                }
            }
        }
    }
    .body {
        margin: 0 24px 0 24px;
        background-color: #fff;
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
        .special {
            display: flex;
            justify-content: flex-start;
            padding: 24px;
            .img-box {
                width: 192px;
                height: 192px;
                background-color: #fafafa;
                border-radius: 10px;
                display: flex;
                img {
                    align-self: center;
                    justify-self: center;
                    border-radius: 10px;
                    display: inline-block;
                    margin: 0 auto;
                    background: #f2f3f5;
                    object-fit: cover;
                }
            }
            .mainPart {
                position: relative;
                padding-left: 24px;
                text-align: left;
                width: calc(100% - 192px);
                .goodName {
                    font-size: 28px;
                    line-height: 40px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    /*! autoprefixer: off */
                    -webkit-box-orient: vertical;
                    white-space: normal;
                    word-break: break-all;
                    width: 100%;
                }
                .goodIntro {
                    font-size: 24px;
                    color: #666666;
                    padding-top: 4px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    /*! autoprefixer: off */
                    -webkit-box-orient: vertical;
                    white-space: normal;
                    word-break: break-all;
                    width: 100%;
                }
                .case {
                    position: absolute;
                    width: calc(100% - 32px);
                    bottom: 0px;
                    .others {
                        padding-top: 24px;
                        position: relative;
                        .price {
                            // width: 250px;
                            .discount {
                                height: 48px;
                                .saleP {
                                    height: 48px;
                                    font-size: 34px;
                                    line-height: 48px;
                                    color: #ff4d4f;
                                    i {
                                        display: inline-block;
                                        font-size: 24px;
                                        transform: scale(0.92);
                                        transform-origin: left 80%;
                                    }
                                    .originP {
                                        margin-left: 8px;
                                        transform: scale(0.83);
                                        color: #999999;
                                        text-decoration: line-through;
                                    }
                                }
                            }
                            .progress-box {
                                height: 28px;
                                display: inline-flex;
                                align-items: center;
                                .progress {
                                    border-radius: 50px;
                                    overflow: hidden;
                                    width: 200px;
                                    span {
                                        position: absolute;
                                        top: 0;
                                        font-size: 40px;
                                        transform: scale(0.5);
                                        color: #ffffff;
                                    }
                                    .alreadyBuy {
                                        width: 400px;
                                        transform-origin: 0 0 0;
                                        left: 6px;
                                    }
                                }
                                .percent {
                                    font-size: 40px;
                                    transform: translateX(-15%) scale(0.5);
                                    color: #ff4d4f;
                                    text-align: center;
                                }
                            }
                        }
                        .btn {
                            box-sizing: border-box;
                            position: absolute;
                            right: 0;
                            bottom: 0;
                            border-radius: 50px;
                            background-color: #ff4d4f;
                            border: 2px solid #ff4d4f;
                            color: #ffffff;
                            font-size: 26px;
                            padding: 0 40px;
                            // height: 48px;
                            line-height: 48px;
                        }
                        .sellOut {
                            background-color: #ffffff;
                            border-radius: 50px;
                            color: #ff4d4f;
                        }
                    }
                }
            }
        }
        .hr {
            border-top: 2px solid #eeeeee;
            margin: 0 24px;
        }
    }
}
</style>
